import React from "react";
import styled from "styled-components";
import { media } from "../../utils/style";
import spaceDust from "../../images/space-dust-3.png";

const Copy = styled.div`
  background: #262168;
  box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.35);
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  margin: 0;
  max-width: 400px;
  padding: 15px 20px 20px;
  position: relative;
  width: 100%;
  color: white;
  text-align: center;
  align-self: flex-end;
  min-width: 320px;
  min-height: 160px;
  justify-content: center;

  &:after {
    background-image: url(${spaceDust});
    background-repeat: no-repeat;
    background-size: contain;
    content: "";
    height: 2441px;
    position: absolute;
    right: -750px;
    top: -700px;
    width: 1796px;
    z-index: -1;
  }

  ${media.tablet`
    margin-left: 20px;
    padding: 35px 40px 40px;
  `};
`;

const Secondary = styled.p`
  color: white;
  text-align: center;
`;

const Primary = styled.h1`
  color: white;
  text-align: center;

  display: flex;
  flex-flow: column nowrap;
`;

class EmailSent extends React.Component {
  render() {
    return (
      <Copy>
        <Primary>Success!</Primary>
        <Secondary>
          Your password has been updated, please return to the Blast app.
        </Secondary>
      </Copy>
    );
  }
}

export default EmailSent;



// WEBPACK FOOTER //
// ./src/components/PasswordUpdated/index.jsx